import styled from 'styled-components'
import Icon from '../Icon/Icon'
import SpinnerIcon from './icon.svg'

const DEFAULT_SIZE = 36

interface LoadingSpinnerProps {
  size?: number
}

const Spinner = styled.div.withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) =>
    !['size', 'color'].includes(prop) && defaultValidatorFn(prop),
})<LoadingSpinnerProps>`
  @keyframes rotating {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  width: 100%;
  height: ${({ size }) => size}px;
  display: flex;
  justify-content: center;

  & svg {
    fill: var(--red);
    animation: rotating 1s linear infinite;
  }
`

const LoadingSpinner = ({ size = DEFAULT_SIZE }: LoadingSpinnerProps) => (
  <Spinner size={size} data-testid="loadingSpinner">
    <Icon size={size}>
      <SpinnerIcon />
    </Icon>
  </Spinner>
)

export default LoadingSpinner
